import { render, staticRenderFns } from "./federated-log-out.page.vue?vue&type=template&id=28c32649&"
import script from "./federated-log-out.page.vue?vue&type=script&lang=ts&"
export * from "./federated-log-out.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports